import { render } from "./courses.vue?vue&type=template&id=7ba2f4b1&scoped=true"
import script from "./courses.vue?vue&type=script&lang=js"
export * from "./courses.vue?vue&type=script&lang=js"

import "./courses.vue?vue&type=style&index=0&id=7ba2f4b1&scoped=true&lang=scss"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba2f4b1"]])

export default __exports__